import { useTranslation } from 'react-i18next'

import { FailedIcon } from '@arcade/web/icons/react'
import { ArcadeButton, ArcadeIconMat, ArcadePageHeader, spacing, Stack } from '@cash-design-system/react'

const goToSupport = () => {
  window.open('/support', '_blank')
}

export const ModalErrorContent = ({
  title,
  message,
  showSupportButton = true,
}: {
  title?: string
  message?: string
  showSupportButton?: boolean
}) => {
  const { t } = useTranslation()

  return (
    <Stack space={spacing.xxl}>
      <ArcadePageHeader
        asset={{
          avatar: (
            <ArcadeIconMat variant="danger">
              <FailedIcon size={32} />
            </ArcadeIconMat>
          ),
        }}
        title={title ?? t('Something went wrong', { context: 'modal title' })}
        titleElement="h1"
        body={message ?? t('Try again or contact support.', { context: 'modal body text' })}
      />
      {showSupportButton && (
        <ArcadeButton onClick={goToSupport} prominence="standard" size="cta">
          {t('Contact Support', { context: 'button text' })}
        </ArcadeButton>
      )}
    </Stack>
  )
}
